import api from './interceptor'
import apiEW from './interceptorEW'

// 我的-个人中心
export const getCustomerInfo = params => {
  return api.get('/customer/getCustomerInfo', { params })
}

export const getEwCustomerInfo = params => {
  return apiEW.get('/occ/order/as/aggregator/client/v1/mall/customer-info', { params })
}

export const setMsgAgree = param => {
  return api.put(`/customer-profile/msg-agree/${param ? 1 : 0}`)
}
